import { useRole, ROLE_TYPES } from "hooks/useRole"

const useHandleStatusValue = (statusCount = {}, leadType = "") => {
  const { isAnyRole, isRole } = useRole()

  const getLabel = (label, value) => {
    if (leadType === "purchase") {
      if (value === "readyToGo") return "Ready"
      if (value === "carBooked") return "Car Checked"
      if (value === "delivered") return "Purchased"
    }
    return label
  }

  const filterStatus = (items) => {
    return items.filter(item => {
      if (leadType === "purchase") {
        return item.value !== "loan"
      } else {
        return item.value !== "parkedForSale"
      }
    })
  }

  const statusConfig = {
    admin: [
      { label: "All", value: "all", count: statusCount?.all, category: "all" },
      { label: "New", value: "new", count: statusCount?.new, category: "management" },
      { label: "Qualified", value: "qualified", count: statusCount?.qualified, category: "management" },
      {
        label: "Processing",
        value: "processing",
        count: statusCount?.processing,
        category: "management"
      },
      { label: getLabel("Ready To Go", "readyToGo"), value: "readyToGo", count: statusCount?.readyToGo, category: "sales" },
      {
        label: getLabel("Car Booked", "carBooked"),
        value: "carBooked",
        count: statusCount?.carBooked,
        category: "sales"
      },
      { label: "Paper Work", value: "paperWork", count: statusCount?.paperWork, category: "sales" },
      { label: "Parked For Sale", value: "parkedForSale", count: statusCount?.parkedForSale, category: "sales" },
      { label: "Loan", value: "loan", count: statusCount?.loan, category: "sales" },
      { label: getLabel("Delivered", "delivered"), value: "delivered", count: statusCount?.delivered, category: "sales" },
      { label: "Lost", value: "lost", count: statusCount?.lost, category: "closed" },
      { label: "Not Qualified", value: "notQualified", count: statusCount?.notQualified, category: "closed" },
      { label: "Not Connected", value: "notConnected", count: statusCount?.notConnected, category: "closed" },
    ],

    enquiryManager: [
      { label: "All", value: "all", count: statusCount?.all, category: "all" },
      { label: "New", value: "new", count: statusCount?.new, category: "management" },
      { label: "Qualified", value: "qualified", count: statusCount?.qualified, category: "management" },
      {
        label: "Processing",
        value: "processing",
        count: statusCount?.processing,
        category: "management"
      },
      { label: "Not Qualified", value: "notQualified", count: statusCount?.notQualified, category: "closed" },
      { label: "Not Connected", value: "notConnected", count: statusCount?.notConnected, category: "closed" },
    ],

    salesManager: [
      { label: "All", value: "all", count: statusCount?.all, category: "all" },
      { label: getLabel("Ready To Go", "readyToGo"), value: "readyToGo", count: statusCount?.readyToGo, category: "sales" },
      {
        label: getLabel("Car Booked", "carBooked"),
        value: "carBooked",
        count: statusCount?.carBooked,
        category: "sales"
      },
      { label: "Paper Work", value: "paperWork", count: statusCount?.paperWork, category: "sales" },
      { label: "Parked For Sale", value: "parkedForSale", count: statusCount?.parkedForSale, category: "sales" },
      { label: "Loan", value: "loan", count: statusCount?.loan, category: "sales" },
      { label: getLabel("Delivered", "delivered"), value: "delivered", count: statusCount?.delivered, category: "sales" },
      { label: "Lost", value: "lost", count: statusCount?.lost, category: "closed" },
    ],

    salesExecutive: [
      { label: "All", value: "all", count: statusCount?.all, category: "all" },
      { label: getLabel("Ready To Go", "readyToGo"), value: "readyToGo", count: statusCount?.readyToGo, category: "sales" },
      {
        label: getLabel("Car Booked", "carBooked"),
        value: "carBooked",
        count: statusCount?.carBooked,
        category: "sales"
      },
      { label: "Paper Work", value: "paperWork", count: statusCount?.paperWork, category: "sales" },
      { label: "Parked For Sale", value: "parkedForSale", count: statusCount?.parkedForSale, category: "sales" },
      { label: "Loan", value: "loan", count: statusCount?.loan, category: "sales" },
      { label: getLabel("Delivered", "delivered"), value: "delivered", count: statusCount?.delivered, category: "sales" },
      { label: "Lost", value: "lost", count: statusCount?.lost, category: "closed" },
    ],
  }

  if (
    isAnyRole([
      ROLE_TYPES.SUPER_ADMIN,
      ROLE_TYPES.ADMIN,
      ROLE_TYPES.MANAGING_DIRECTOR,
      ROLE_TYPES.GENERAL_MANAGER,
      ROLE_TYPES.BRANCH_MANAGER,
      ROLE_TYPES.SALES_EXECUTIVE,
      ROLE_TYPES.ENQUIRY_MANAGER
    ])
  ) {
    return filterStatus(statusConfig.admin)
  }
  if (isRole(ROLE_TYPES.SALES_MANAGER)) {
    return filterStatus(statusConfig.salesManager)
  }
  if (isAnyRole([ROLE_TYPES.ENQUIRY_ANALYST,])) {
    return filterStatus(statusConfig.enquiryManager)
  }
  return filterStatus(statusConfig.admin)
}

export default useHandleStatusValue
